import React, { memo } from 'react';
import { string, bool, func } from 'prop-types';

const Checkbox = ({
  testId,
  name,
  register,
  required,
  defaultChecked,
  isDisabled,
  onChange,
  className,
  type,
  id = name,
  ...rest
}) => {
  const _onChange = (event) => {
    if (onChange) {
      event.stopPropagation();
      onChange();
    }
  };

  return (
    <input
      {...register(name, { required })}
      type={type}
      id={id}
      data-testid={testId}
      className={`border-gray-200 focus:ring-offset-0 focus:ring-0 mr-2 rounded-md p-2 ${
        isDisabled ? '' : 'cursor-pointer'
      } ${className}`}
      disabled={isDisabled}
      onClick={_onChange}
      {...rest}
    />
  );
};

Checkbox.propTypes = {
  testId: string,
  name: string,
  defaultChecked: bool,
  required: bool,
  register: func,
  isDisabled: bool,
  className: string,
  type: string,
};
Checkbox.defaultProps = {
  testId: 'checkbox',
  name: 'checkbox',
  defaultChecked: false,
  register: () => null,
  isDisabled: false,
  className: 'text-brand-primary',
  type: 'checkbox',
};

export default memo(Checkbox);
